import React from "react";
import { useSelector } from "react-redux";
import Skeleton, { SkeletonProps } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./LoadingComponent.module.scss";

interface Props extends SkeletonProps {}

const LoadingComponent = (props: Props) => {
  const mode = useSelector((state: any) => state.theme.mode); // themeSlice-dəki mode

  return (
    <div className={styles.skeleton_wrapper} data-theme={mode}>
      <Skeleton
        borderRadius={8}
        baseColor={mode === "dark" ? "#333" : "#e0e0e0"}
        highlightColor={mode === "dark" ? "#555" : "#f5f5f5"}
        {...props}
      />
    </div>
  );
};

export default LoadingComponent;
